// Central content + media data for the Vivid Cruises Sydney landing page.
// SEO friendly filename, alt, title and caption on every image.

const ux = (url, w = 1200, q = 72) => `${url}?auto=format&fit=crop&w=${w}&q=${q}`;

const VCS_EXTERIOR = "https://customer-assets.emergentagent.com/job_magic-cruise-sydney/artifacts/q1j2aq6h_MAGIC%20CRUISES%20BOAT%20SYDNEY.png";
const HERO_BANNER = "https://customer-assets.emergentagent.com/job_magic-cruise-sydney/artifacts/750lseng_vivid%20harbour%20cruise%20sydney.png";
const VCS_DECK = "https://static.prod-images.emergentagent.com/jobs/4e7d0aa8-0aad-4281-9a28-f5dba8332f58/images/55655982e385658dbef07bceacb0dd48741d7c48c3d26d1959cdc781f38d2629.png";
const VCS_BAR = VCS_DECK;

// Real Vivid Sydney festival photos (Sydney landmarks)
const VIVID_OPERA_PURPLE = "https://customer-assets.emergentagent.com/job_magic-cruise-sydney/artifacts/22in0wem_vivid-opera-house-magic-cruies.jpg";
const VIVID_OPERA_LASER = "https://customer-assets.emergentagent.com/job_magic-cruise-sydney/artifacts/ui46o7k0_VIVID-CRUISE-MAGIC.jpg";
const VIVID_BRIDGE = "https://customer-assets.emergentagent.com/job_magic-cruise-sydney/artifacts/oaf5uloz_harbour-cruise-vivid-sydney.jpg";
const VIVID_HARBOUR_LASERS = "https://customer-assets.emergentagent.com/job_magic-cruise-sydney/artifacts/6v33u5yj_vivid-cruise-sydney-harbour.jpg";

export const IMAGES = {
  hero: {
    src: HERO_BANNER,
    filename: "vivid-cruises-sydney-harbour-cruise.jpg",
    alt: "Vivid Cruises Sydney Harbour cruise sailing past the Sydney Opera House and Harbour Bridge lit with colourful Vivid Sydney festival lights at night",
    title: "Vivid Cruises Sydney, Vivid Cruise Sydney Harbour",
    caption: "Cruise Vivid Sydney on Sydney Harbour with front row views of the Opera House and Harbour Bridge.",
  },
  operaMagenta: {
    src: VIVID_OPERA_PURPLE,
    filename: "vivid-sydney-opera-house-cruise.jpg",
    alt: "Sydney Opera House sails illuminated in purple and blue Vivid Sydney light projections viewed from a Vivid Cruises Sydney harbour cruise at night",
    title: "Vivid Sydney Opera House from a Vivid Cruises Sydney cruise",
    caption: "The Sydney Opera House glows during Vivid Sydney, a highlight of the Vivid Cruises Sydney harbour cruise.",
  },
  operaColour: {
    src: VIVID_OPERA_LASER,
    filename: "sydney-vivid-cruise-opera-house-lights.jpg",
    alt: "Sydney Opera House sails covered in colourful green, cyan and purple Vivid Sydney light line projections at night",
    title: "Sydney Vivid Cruise, Opera House light installations",
    caption: "Vivid Sydney colour projections wrap the Opera House sails.",
  },
  operaSkyline: {
    src: VIVID_OPERA_PURPLE,
    filename: "vivid-sydney-harbour-cruise-skyline.jpg",
    alt: "Sydney Opera House glowing purple and blue during Vivid Sydney viewed from the harbour",
    title: "Vivid Sydney Harbour Cruise, Opera House and skyline",
    caption: "The Opera House illuminated across the harbour during Vivid Sydney.",
  },
  bridgeLights: {
    src: VIVID_BRIDGE,
    filename: "vivid-harbour-cruise-sydney-bridge-lights.jpg",
    alt: "Sydney Harbour Bridge glowing blue and purple during Vivid Sydney beside the illuminated waterfront reflecting on the water",
    title: "Vivid Harbour Cruise Sydney, Harbour Bridge light show",
    caption: "The Sydney Harbour Bridge comes alive with light during Vivid Sydney.",
  },
  lightShowBoat: {
    src: VCS_EXTERIOR,
    filename: "vivid-cruise-on-sydney-harbour.jpg",
    alt: "Vivid Cruises Sydney vessel on Sydney Harbour with vibrant Vivid Sydney lights on the Harbour Bridge reflecting on the water at night",
    title: "Vivid Cruise on Sydney Harbour",
    caption: "Vivid Sydney light installations glow around the Vivid Cruises Sydney vessel.",
  },
  darlingHarbour: {
    src: VIVID_HARBOUR_LASERS,
    filename: "sydney-harbour-cruises-vivid-darling-harbour.jpg",
    alt: "Blue Vivid Sydney laser beams fanning across Circular Quay and the city skyline over the harbour at night",
    title: "Sydney Harbour Cruises Vivid, harbour laser light show",
    caption: "Vivid Sydney laser beams light up the harbour, seen from a Vivid Cruises Sydney cruise.",
  },
  operaFromShip: {
    src: VCS_DECK,
    filename: "sydney-harbour-boat-cruise-vivid-deck.jpg",
    alt: "Guests on the open deck of the Vivid Cruises Sydney vessel enjoying the colourful Vivid Sydney skyline at night",
    title: "Sydney Harbour Boat Cruise Vivid, open deck",
    caption: "Guests enjoy front row Vivid views from the open deck.",
  },
  deckDusk: {
    src: VCS_DECK,
    filename: "private-vivid-cruises-sydney-deck.jpg",
    alt: "Spacious outdoor viewing deck of the Vivid Cruises Sydney vessel with guests during Vivid Sydney at night",
    title: "Private Vivid Cruises Sydney, open viewing deck",
    caption: "Spacious outdoor viewing decks during Vivid Sydney.",
  },
  candlelitDeck: {
    src: VCS_DECK,
    filename: "vivid-cruises-sydney-dining.jpg",
    alt: "Relaxed seating on the deck of a Vivid Cruises Sydney harbour cruise during Vivid Sydney",
    title: "Vivid Cruises Sydney, relaxed deck seating",
    caption: "Comfortable, atmospheric seating on board.",
  },
  couple: {
    src: VCS_DECK,
    filename: "best-vivid-cruises-sydney-couple.jpg",
    alt: "Guests watching the colourful Vivid Sydney skyline from the deck of a Vivid Cruises Sydney cruise at night",
    title: "Best Vivid Cruises Sydney, romantic harbour views",
    caption: "A memorable evening on the water during Vivid Sydney.",
  },
  bar: {
    src: VCS_BAR,
    filename: "vivid-sydney-boat-cruise-bar-deck.jpg",
    alt: "Guests enjoying drinks at the licensed bar on the open deck of a Vivid Cruises Sydney harbour cruise during Vivid Sydney at night",
    title: "Vivid Cruises Sydney, onboard licensed bar and deck",
    caption: "Guests relax at the fully licensed bar on the open deck during Vivid Sydney.",
  },
  skylineSea: {
    src: VIVID_HARBOUR_LASERS,
    filename: "vivid-sydney-harbour-cruise-city-lights.jpg",
    alt: "Vivid Sydney laser beams and colourful city skyline lights reflecting on the harbour water at night",
    title: "Vivid Sydney Harbour Cruise, city lights from the water",
    caption: "The glittering Vivid Sydney skyline reflected on the harbour at night.",
  },
};

export const GALLERY = [
  IMAGES.operaMagenta,
  IMAGES.bridgeLights,
  IMAGES.darlingHarbour,
  IMAGES.operaColour,
  IMAGES.lightShowBoat,
  IMAGES.operaFromShip,
];

// Vivid Cruises Sydney 2027 departure dates and cruise sessions
export const CRUISE_DATES = [
  { iso: "2027-05-28", day: "28", month: "May", weekday: "Fri", type: "Weeknight", times: ["6:00pm", "7:30pm"] },
  { iso: "2027-05-29", day: "29", month: "May", weekday: "Sat", type: "Weekend", times: ["6:00pm", "7:30pm", "9:00pm"] },
  { iso: "2027-05-30", day: "30", month: "May", weekday: "Sun", type: "Weekend", times: ["6:00pm", "7:30pm"] },
  { iso: "2027-06-03", day: "3", month: "June", weekday: "Thu", type: "Weeknight", times: ["6:00pm", "7:30pm"] },
  { iso: "2027-06-04", day: "4", month: "June", weekday: "Fri", type: "Weeknight", times: ["6:00pm", "7:30pm"] },
  { iso: "2027-06-05", day: "5", month: "June", weekday: "Sat", type: "Weekend", times: ["6:00pm", "7:30pm", "9:00pm"] },
  { iso: "2027-06-06", day: "6", month: "June", weekday: "Sun", type: "Weekend", times: ["6:00pm", "7:30pm"] },
  { iso: "2027-06-10", day: "10", month: "June", weekday: "Thu", type: "Weeknight", times: ["6:00pm", "7:30pm"] },
  { iso: "2027-06-11", day: "11", month: "June", weekday: "Fri", type: "Weeknight", times: ["6:00pm", "7:30pm"] },
  { iso: "2027-06-12", day: "12", month: "June", weekday: "Sat", type: "Weekend", times: ["6:00pm", "7:30pm", "9:00pm"] },
  { iso: "2027-06-13", day: "13", month: "June", weekday: "Sun", type: "Weekend", times: ["6:00pm", "7:30pm"] },
  { iso: "2027-06-17", day: "17", month: "June", weekday: "Thu", type: "Weeknight", times: ["6:00pm", "7:30pm"] },
  { iso: "2027-06-18", day: "18", month: "June", weekday: "Fri", type: "Weeknight", times: ["6:00pm", "7:30pm"] },
  { iso: "2027-06-19", day: "19", month: "June", weekday: "Sat", type: "Weekend", finale: true, times: ["6:00pm", "7:30pm", "9:00pm"] },
];

export const LANDMARKS = [
  { name: "Sydney Opera House", note: "Iconic Vivid light projections across the sails." },
  { name: "Sydney Harbour Bridge", note: "The 'Coathanger' glowing above the water." },
  { name: "Circular Quay", note: "The vibrant heart of Vivid Sydney." },
  { name: "Barangaroo", note: "Waterfront installations and reflections." },
  { name: "Luna Park", note: "The famous face lit up at Milsons Point." },
  { name: "Darling Harbour", note: "Colour, lasers and waterfront light art." },
  { name: "The Rocks", note: "Historic laneways bathed in Vivid colour." },
  { name: "Sydney skyline at night", note: "A 360° panorama of illuminated towers." },
];

export const OCCASIONS = [
  { key: "private", title: "Private Vivid Charters", blurb: "Exclusive use of the vessel for your group with a tailored route through the best Vivid Sydney installations." },
  { key: "corporate", title: "Corporate Vivid Cruises", blurb: "Impress clients and reward teams with a premium branded Sydney Harbour Vivid experience." },
  { key: "birthday", title: "Birthday Cruises", blurb: "Celebrate on the water with a licensed bar, music and unforgettable Vivid Sydney views." },
  { key: "family", title: "Family Cruises", blurb: "A safe, comfortable and magical Vivid night out for all ages that kids love." },
  { key: "group", title: "Group Bookings", blurb: "Friends, clubs, schools and social groups enjoy flexible group rates on Vivid Cruises Sydney." },
  { key: "romantic", title: "Romantic Cruises", blurb: "Front row harbour views make Vivid Cruises Sydney one of the most romantic Vivid cruises in Sydney." },
];

export const REASONS = [
  { title: "Front row Vivid views", text: "Unobstructed vantage points of every major installation, with no crowds and no barriers, just the water and the light." },
  { title: "Premium comfort", text: "Spacious indoor saloon and open air decks, comfortable seating and a fully licensed bar keep the night effortless." },
  { title: "Best value on the harbour", text: "Adults from $49 and kids from $35 for a full Vivid Cruises Sydney harbour cruise experience." },
  { title: "Local expertise", text: "Our skippers know exactly where and when the harbour looks its most spectacular during Vivid Sydney." },
];

export const FAQS = [
  { q: "What is a Vivid Sydney cruise?", a: "A Vivid Sydney cruise is a Sydney Harbour boat cruise that runs during the Vivid Sydney festival of light, music and ideas. With Vivid Cruises Sydney you get front row, unobstructed views of the light installations on the Sydney Opera House, Sydney Harbour Bridge, Circular Quay, Barangaroo, Luna Park and Darling Harbour, all from the comfort of the water, away from the shoreline crowds." },
  { q: "How much does a Vivid Cruises Sydney harbour cruise cost?", a: "Tickets are $49 for adults and $35 for children. You can book instantly online through our secure Stripe checkout. Private charter and group rates are available on request, so just send us an enquiry." },
  { q: "Where does Vivid Cruises Sydney depart from?", a: "Vivid Cruises Sydney departs from King Street Wharf, Wharf 3, in Darling Harbour, a short walk from Wynyard station and the light rail. Your boarding time is confirmed with your booking so you can plan your evening with ease." },
  { q: "When is Vivid Sydney 2027 and what dates can I cruise?", a: "Vivid Cruises Sydney runs evening cruises from Friday 28 May through to the festival finale on Saturday 19 June 2027, with weeknight and weekend sailings at 6:00pm, 7:30pm and 9:00pm on selected nights. Evening sailings during Vivid are the most popular cruises of the Sydney calendar, so we strongly recommend booking early to secure your preferred night." },
  { q: "What will I see on the Vivid Cruises Sydney harbour cruise?", a: "You'll cruise past the illuminated Sydney Opera House, glide beneath the Sydney Harbour Bridge, take in Circular Quay, Barangaroo, the Sydney skyline, Luna Park at Milsons Point and the colour of Darling Harbour, the very best of the Vivid Sydney light installations, all from the water." },
  { q: "Is there a bar on board?", a: "Yes. Vivid Cruises Sydney features a fully licensed bar serving beer, wine, spirits and soft drinks throughout the cruise, so you can relax with a drink in hand while the harbour lights up around you." },
  { q: "Is the Vivid cruise suitable for families and children?", a: "Absolutely. Vivid Cruises Sydney is a family friendly cruise with comfortable indoor and outdoor viewing areas. Children's tickets are $35 and kids are captivated by the colour and spectacle of Vivid Sydney from the water." },
  { q: "Can I book a private charter for Vivid Sydney?", a: "Yes. Vivid Cruises Sydney is available for private Vivid charters including corporate events, birthdays, and group celebrations. Enjoy exclusive use of the vessel and a route tailored to the best installations. Send an enquiry for availability and pricing." },
  { q: "How long does the Vivid cruise go for?", a: "Most Vivid Cruises Sydney harbour cruises run for approximately 1.5 hours, giving you ample time to experience the full sweep of the harbour's Vivid installations at a relaxed pace." },
  { q: "What should I wear and bring?", a: "Sydney evenings on the water can be cool during Vivid, so bring a warm jacket. Comfortable shoes, a charged phone or camera for photos, and your booking confirmation are all you need. Everything else is taken care of on board." },
  { q: "What happens if the weather is bad?", a: "Vivid Cruises Sydney is a comfortable, weatherproof vessel with a spacious enclosed saloon, so the cruise proceeds in most conditions and you'll stay warm and dry while enjoying the lights. In the rare event of a cancellation for safety, we'll contact you about rescheduling." },
  { q: "How do I get the best photos of Vivid Sydney?", a: "The open decks are a photographer's dream. For the sharpest night shots, steady your phone or camera on the rail, lower your shutter speed slightly, and capture the Opera House and Harbour Bridge as you glide past, as the reflections on the water make for unforgettable images." },
];

export const TESTIMONIALS = [
  { name: "Sarah M.", location: "Sydney", rating: 5, text: "Hands down the best way to see Vivid. We floated right past the Opera House while it was lit up and the whole family was mesmerised. Vivid Cruises Sydney was a beautiful experience and the bar was a lovely touch." },
  { name: "James T.", location: "Melbourne", rating: 5, text: "Booked Vivid Cruises Sydney for my partner's birthday. Front row views of the Harbour Bridge light show, great atmosphere and zero crowds. Worth every dollar." },
  { name: "Priya K.", location: "Parramatta", rating: 5, text: "We did a group booking for work and everyone raved about it. Circular Quay and Barangaroo looked incredible from the water. Will absolutely do it again next Vivid." },
  { name: "Daniel & Emma", location: "Bondi", rating: 5, text: "The most romantic night. Watching the Vivid installations from the deck with a glass of wine was unforgettable. Highly recommend Vivid Cruises Sydney." },
  { name: "Michelle R.", location: "North Sydney", rating: 5, text: "Took the kids and they loved seeing Luna Park lit up. Comfortable, easy boarding at King Street Wharf, Wharf 3 and the crew were fantastic. Best value Vivid cruise in Sydney." },
  { name: "Anthony P.", location: "Sydney CBD", rating: 5, text: "As a photographer, the open deck was perfect. Got stunning shots of the Opera House and skyline. Vivid Cruises Sydney is now my favourite Vivid Sydney harbour cruise." },
];

export const TRUST = [
  "4.9★ from 687+ guests",
  "Front row Vivid views",
  "Fully licensed bar",
  "Departs King Street Wharf, Wharf 3",
  "Secure online booking",
  "Family friendly",
  "Private charters available",
  "Local Sydney operator",
];

export const NAV_LINKS = [
  { label: "Why Vivid by Water", href: "#why-water" },
  { label: "The Cruise", href: "#about" },
  { label: "Highlights", href: "#highlights" },
  { label: "Dates", href: "#dates" },
  { label: "Occasions", href: "#occasions" },
  { label: "Tickets", href: "#tickets" },
  { label: "Reviews", href: "#reviews" },
  { label: "FAQ", href: "#faq" },
];

export const CONTACT = {
  email: "info@vividcruisessydney.com.au",
  brand: "Vivid Cruises Sydney",
  tagline: "Enjoy your Sydney Harbour Cruise Event",
  depart: "King Street Wharf, Wharf 3, Sydney NSW 2000",
  directions: "https://www.google.com/maps/search/?api=1&query=King+Street+Wharf+3+Sydney",
};
